import React from "react";
import {useState, useEffect} from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { supabase } from '../utils/supabaseClient';
import { Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Textarea,
    // Input,
    ModalCloseButton,
    ModalBody,
    FormControl,
    FormLabel,
    FormErrorMessage,
    useToast,
    Button,
    SkeletonText } from "@chakra-ui/react"


const BioModal = (props) => {

  const initialRef = React.useRef(null)
  const finalRef = React.useRef(null)

  const [bioEntry, setBioEntry] = useState();
  const [isBioLoading, setIsBioLoading] = useState(true);

  const toast = useToast();

  useEffect(() => {
    if (!props.isOpen) {
      return;
    }

    let cancelled = false;

    const dataFetch = async () => {
      setIsBioLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      const apiBearer = session?.access_token || null;
      const apiUserUuid = session?.user?.id || null;
      if (!apiBearer || !apiUserUuid) {
        if (!cancelled) {
          setIsBioLoading(false);
        }
        return;
      }
      const authHeaders = { Authorization: `Bearer ${apiBearer}` };
      try {
        const res = await fetch(
          `https://sckumwyv6l.execute-api.eu-central-1.amazonaws.com/testas/user-data?userUuid=${encodeURIComponent(apiUserUuid)}`,
          { method: 'GET', headers: authHeaders }
        );
        const data = await res.json();
        if (!cancelled) {
          setBioEntry(data);
        }
      } catch (error) {
        console.error('Error fetching bio:', error);
      } finally {
        if (!cancelled) {
          setIsBioLoading(false);
        }
      }
    };

    dataFetch();

    return () => {
      cancelled = true;
    };
  }, [props.isOpen]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      bio: bioEntry ?? ''
    },
    validationSchema: Yup.object({
      bio: Yup.string()
        .max(1000, 'Ne daugiau kaip 1000 simbolių!')
        // .required('Trūksta informacijos apie Jus'),
    }),
    onSubmit: async (values) => {
      // console.log(values);
        const { data: { session } } = await supabase.auth.getSession();
        const apiBearer = session?.access_token || null;
        const apiUserUuid = session?.user?.id || null;
        if (!apiBearer || !apiUserUuid) {
          return;
        }
        fetch('https://sckumwyv6l.execute-api.eu-central-1.amazonaws.com/testas/user-data', {
          headers: {
            Authorization: `Bearer ${apiBearer}`,
            "Content-Type": "application/json"
          },
          method: 'POST',
          body: JSON.stringify({
            "userUuid": apiUserUuid,
            "bio": values.bio})
        })
        .then(
          success => {
            setBioEntry(values.bio);
            // console.log(success);
            props.onModalClose();
            toast({
              title: 'Ačiū',
              description: "Informacija apie Jus išsaugota",
              status: 'success',
              duration: 3000,
              isClosable: true,
            })
           }
        )
        .catch(
          error => console.dirxml(error.message) // Handle the error response object
        );        
    }});  

  return (
    <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={props.isOpen}
        onClose={props.onModalClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Apie mane</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isInvalid={formik.touched.bio && formik.errors.bio}>
              <FormLabel>Trumpai apie Jus</FormLabel>
              {isBioLoading ? (
                <SkeletonText mt={2} noOfLines={4} spacing={3} />
              ) : (
              <Textarea
                id="bio"
                placeholder="Trumpai apie Jus"
                {...formik.getFieldProps('bio')}
              />
              )}
              {/* <Input 
              id="bio"
              type="text"
              // ref={initialRef} 
              placeholder={bioEntry}
              _placeholder={{ opacity: 1, color: 'black' }}
              {...formik.getFieldProps('bio')
            }
              /> */}
              <FormErrorMessage>{formik.errors.bio}</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button 
            colorScheme='white' 
            color='black.500'
            borderColor='black.500'
            borderWidth='2px'
            variant='outline'
            sx={{
              '&:hover': {
                bg: "rgba(251, 143, 255, 0.4)"
              },
            }}
             mr={3} onClick={formik.handleSubmit}>
              Išsaugoti
            </Button>
            <Button 
                  colorScheme='white' 
                  color='black.500'
                  borderColor='black.500'
                  borderWidth='2px'
                  variant='outline'
                  sx={{
                    bg: "#E9E9E9",
                  }}
            onClick={props.onModalClose}
            >Atšaukti</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )

};

export default BioModal;